module.exports = __webpack_public_path__ + "img/phone-section-introduction.337623cb.png";